module.exports = __webpack_public_path__ + "img/ieee2021wxpay.c1d3cc92.jpg";